module.exports = __webpack_public_path__ + "static/media/ic_location.deceb3d4.svg";